import React, { useEffect, useRef } from 'react'
import Countdown, { zeroPad } from 'react-countdown'
import moment from 'moment'
import { ShortDescriptionPropsType, TimerType } from './types'
import { selectElementText } from '@alidev/text-select/dist'

// Components
import NotionRenderer from '@famiryru/react-notion-renderer'

// Styles
import './styles.scss'

// Icons
import IconGirl from './images/iconGirl'

export default ({
  title,
  style,
  blocks,
  isBlockingTime,
  isAvailable,
  onComplete,
}: ShortDescriptionPropsType) => {
  const timeLeft = moment(isBlockingTime).toDate()

  const refTimer = useRef<Countdown>(null)
  const refOuter = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    setTimeout(() => {
      if (refOuter.current) {
        selectElementText(refOuter.current)
        window.getSelection()?.removeAllRanges()
      }
    })
  }, [title])

  useEffect(() => {
    if (!isAvailable && refTimer.current) {
      setTimeout(() => {
        const timerNode = document.getElementById('time')
        if (timerNode) {
          selectElementText(timerNode)
        }
        refTimer.current?.start()
      })
    }
  }, [refTimer, isAvailable])

  const rendererTimer = ({ days, hours, minutes, seconds }: TimerType) => (
    <>
      {`${zeroPad(days)}дн ${zeroPad(hours)}:${zeroPad(minutes)}:${zeroPad(
        seconds
      )}`}
    </>
  )

  return (
    <div style={style} className={'short'}>
      <div className={'short__icon'}>
        <IconGirl />
      </div>
      <div ref={refOuter} className={'short__description'}>
        <div className={'title'}>{title}</div>
        {isAvailable ? (
          <NotionRenderer blocks={blocks} />
        ) : (
          <div className={'short__blocked'}>
            Данный урок сейчас заблокирован. Он будет разблокирован <br /> по
            истечении обратного отсчета:
            <div id={'time'} className={'short__blocked-time'}>
              <Countdown
                ref={refTimer}
                date={timeLeft}
                renderer={rendererTimer}
                autoStart={true}
                onComplete={onComplete}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
